import { GenericMoleculeOverviewRowPanelDashboardComponent } from '../abstract';

// tslint:disable-next-line:max-line-length
export class MoleculeOverviewRowPanelDashboardStorageComponent extends GenericMoleculeOverviewRowPanelDashboardComponent {
    public template = require('./dashboard-storage.html');
    protected type = 'storage';
}
